import { useState, useCallback } from "react";
import { useOnScroll } from "./useOnScroll";
import { useCallbackRef } from "./useCallbackRef";

export const useIsInViewport = () => {
    const [bounding, setBounding] = useState();
    const [ref, node] = useCallbackRef();

    const onScroll = useCallback(() => node && setBounding(node.getBoundingClientRect()), [node]);
    useOnScroll(onScroll);

    if (!bounding) return [ref, true];

    const top = bounding.top + bounding.height;
    const left = bounding.left + bounding.width;
    const bottom = bounding.bottom - bounding.height;
    const right = bounding.right - bounding.width;

    return [
        ref,
        top >= 0 && left >= 0 && bottom <= window.innerHeight && right <= window.innerWidth
    ];
};
